<template>
  <div
    :id="id"
    :style="{ backgroundImage: `url('${heroHeaderImage}')` }"
    :class="[wrapperClasses, heroHeaderImageFocalPoint]"
  >
    <div
      class="container mx-auto flex max-w-screen-xl flex-col items-center space-y-10 p-6 md:p-12 lg:flex-row lg:space-x-24"
    >
      <div
        v-if="showLoginHero && !isAuthenticated"
        class="w-full rounded bg-white p-6 text-[color:var(--color-body-text)] shadow-lg md:p-10 lg:w-2/5"
      >
        <h1 v-t="'pages.home.sign_in_form_title'" class="mb-8"></h1>
        <SignInForm grow-buttons @succeeded="onSignIn" />
      </div>
      <div class="w-full select-none text-center text-3xl font-bold drop-shadow-lg md:text-5xl lg:w-3/5 lg:text-left">
        <div class="mb-8">
          <div class="leading-tight" v-html="heroTitle"></div>
          <div class="text-2xl" v-html="heroSubtitle"></div>
        </div>
        <div
          class="flex flex-col items-center justify-center space-y-2 text-xl md:flex-row md:space-x-7 md:space-y-0 md:text-2xl lg:justify-start"
        >
          <template v-for="(usp, index) in heroUsps" :key="index">
            <div v-t="usp.heroUsp"></div>
            <div v-if="index + 1 != heroUsps?.length" class="h-2.5 w-2.5 rounded-full bg-white"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SignInForm, useUser } from "@/shared/account";

type HeroUspsType = {
  heroUsp: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  showLoginHero?: boolean;
  heroTitle?: string;
  heroSubtitle?: string;
  heroHeaderImage?: string;
  heroHeaderImageFocalPoint?: string;
  heroUsps?: Array<HeroUspsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.heroHeaderImageFocalPoint ? props.heroHeaderImageFocalPoint : "",
    props.textColor ? props.textColor : "text-white",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-0",
    "banner flex items-center",
  ];
});

const { isAuthenticated } = useUser();

function onSignIn() {
  location.href = "/account/dashboard";
}
</script>

<style scoped>
.banner {
  position: relative;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  min-height: 650px;
}

@media (min-width: 1600px) {
  .banner {
    min-height: 900px;
  }
}
</style>
